import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "checkboxShow", "clearListBtn", "optionBtn",
                    "masterMultipleCheckDiv", "masterMultipleCheck", "multipleCheck", "bindSum", "searchInput", "payCommissionBtn"]

  connect() {
    this.controllerName = `financials--products--commissions--entities--index`
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.itemsOnPage = 300
    this.pageNumber = 0
    this.numberPages = []
    this.tableCols = 15
    this.sort = { mode: `asc`, field: `kind` }
    this.hasShow = false
  }

  addCommission() {
    this.showClearBtn()

    this.getControllerByIdentifier("financials--products--commissions--entities--save").actionMode = "new"
    this.getControllerByIdentifier("financials--products--commissions--entities--save").current_commission = {}
    this.getControllerByIdentifier("financials--products--commissions--entities--save").doFormHtml()
  }

  copyCommission(ev) {
    var commissionId = ev.target.closest(".itemRow").dataset.id
    var current_commission = {}

    this.application.commissions.forEach(element => {
      if (element.id == commissionId) {
        current_commission = element
      }
    })

    this.showClearBtn()

    this.getControllerByIdentifier("financials--products--commissions--entities--save").actionMode = "copy"
    this.getControllerByIdentifier("financials--products--commissions--entities--save").current_commission = current_commission
    this.getControllerByIdentifier("financials--products--commissions--entities--save").doFormHtml()
  }

  editCommission(ev) {
    var commissionId = ev.target.closest(".itemRow").dataset.id
    var current_commission = {}

    this.application.commissions.forEach(element => {
      if (element.id == commissionId) {
        current_commission = element
      }
    })

    this.showClearBtn()

    this.getControllerByIdentifier("financials--products--commissions--entities--save").actionMode = "edit"
    this.getControllerByIdentifier("financials--products--commissions--entities--save").current_commission = current_commission
    this.getControllerByIdentifier("financials--products--commissions--entities--save").doFormHtml()
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doIndexListHtml() {
    if (this.application.permissions[this.permission].can_create) {
      var addLine = `<span data-action="click->${this.controllerName}#addCommission" class="dropdown-item py-1 pointer dropdown-submenu-item">Adicionar Comissão</span>`
    } else {
      var addLine = ``
    }
    var addLine = ``

    if (this.application.permissions[this.permission].can_manage) {
      var editLine = `<span data-action="click->${this.controllerName}#checkForEditCommission" class="dropdown-item py-1 pointer dropdown-submenu-item">Editar Comissão</span>`
    } else {
      var editLine = ``
    }

    if (this.application.permissions[this.permission].can_manage) {
      var payLine = `<span data-action="click->${this.controllerName}#checkForPayCommission" class="dropdown-item py-1 pointer dropdown-submenu-item">Pagar Comissões</span>`
    } else {
      var payLine = ``
    }

    if (this.application.permissions[this.permission].can_manage) {
      var copyLine = `<span data-action="click->${this.controllerName}#checkForCopyCommission" class="dropdown-item py-1 pointer dropdown-submenu-item">Copiar Comissão</span>`
    } else {
      var copyLine = ``
    }

    var sumCommisionsLine = `<span data-action="click->${this.controllerName}#checkForSumCommission" class="dropdown-item py-1 pointer dropdown-submenu-item">Somar Comissões</span>`
    var refreshLine = `<span data-action="click->${this.controllerName}#refreshCommissions" class="dropdown-item py-1 pointer dropdown-submenu-item">Atualizar Comissões</span>`

    var clearBtnHtml = `<span class="mc-tooltip">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0 d-none" data-${this.controllerName}-target="clearListBtn" data-action="click->${this.controllerName}#clearList" type="button">
                            <span class="material-icons md-dark">clear</span>
                          </button>
                          <span class="mc-tooltiptext">Limpar</span>
                        </span>`

    // filter_list
    var submenuHtml = `<div class="dropdown mc-tooltip" data-${this.controllerName}-target="optionBtn">
                        <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-toggle="dropdown" id="submenuMenuDrop" type="button"><span class="material-icons md-dark">more_vert</span></button>
                        <div aria-labelledby="submenuMenuDrop" class="dropdown-menu dropdown-menu-right menu" style="font-size:80%">
                          ${addLine}
                          ${refreshLine}
                          ${editLine}
                          ${copyLine}
                          ${payLine}
                          ${sumCommisionsLine}
                        </div>
                        <span class="mc-tooltiptext">Opções</span>
                      </div>`

    // `<th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle">Serviço</th>`
    // `<th style="font-size:80%;" scope="col" class="pointer p-1 table-7 align-middle">Produto</th>`
    // `<th style="font-size:80%;" scope="col" class="pointer p-1 table-7 align-middle">Serviço</th>`

    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <div class="custom-control custom-checkbox px-2 d-none" data-${this.controllerName}-target="masterMultipleCheckDiv">
                      <input type="checkbox" class="custom-control-input" id="masterCheck" data-${this.controllerName}-target="masterMultipleCheck" data-action="click->${this.controllerName}#checkAll">
                      <label class="custom-control-label f-065" for="masterCheck"></label>
                    </div>
                    <h6 class="card-title display-4 card-title-table-list">Todas as Comissões</h6>
                    <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-${this.controllerName}-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                    <div class="card-actions ml-auto py-0">
                      ${clearBtnHtml}
                      ${submenuHtml}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" style="font-size:80%;">
                          <thead>
                            <tr>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-2 align-middle"></th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">Contratação</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-7 align-middle">Jornada</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-7 align-middle">Produto</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-7 align-middle">Tipo</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-7 align-middle">Serviço</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-7 align-middle">Contrato</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-7 align-middle">Financeiro</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-7 align-middle">Status</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle">Política</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Tipo</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Base</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-4 align-middle">Percentual</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Comissão</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle">MedCapital</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-3 align-middle">Área</th>
                            </tr>
                          </thead>
                          <tbody data-${this.controllerName}-target="bodyTable">
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--products--commissions--entities--dashboard").mainTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.6) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 10))
      controller.doDataTable()
    })
  }

  doDataTable() {
    var current_commissions = this.application.commissions

    if (this.sort.mode == `asc`) {
      var commissions = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(current_commissions, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var commissions = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(current_commissions, this.sort.field)
    }

    if (commissions.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(commissions.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (commissions[x] !== undefined) {
            internPage[internPage.length] = commissions[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: commissions.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="${this.tableCols}" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Comissões</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.commissionTablePartial(element, data.length))
      });
    }
  }

  commissionTablePartial(element, length) {

    element.name = ``

    this.application.purchases.forEach(purchase => {
      if (purchase.id == element.purchase_id) {
        element.purchase_token = purchase.token
        element.journey_status = purchase.journey_status_pretty
        purchase.parties.forEach(party => {
          element.name += `<p class="mb-0 f-065 f-bold" data-${this.controllerName}-target="purchasePartyName">${party.party_name}</p>`
        })  
      }
    })

    var signedStatus = ``
    if (element.has_signed) {
      var signedStatus = `<span class="badge badge-secondary-primary">Assinatura Ok</span>`
    } else {
      var signedStatus = `<span class="badge badge-secondary-danger">Não Assinado</span>`
    }

    var chargedStatus = ``
    if (element.has_charged) {
      var chargedStatus = `<span class="badge badge-secondary-primary">Fatura Ok</span>`
    } else {
      var chargedStatus = `<span class="badge badge-secondary-danger">Não Pago</span>`
    }

    var statusPretty = ``
    if (element.status == `not_validated`) {
      var statusPretty = `<span class="badge badge-secondary-danger">${element.status_pretty}</span>`
    } else if (element.status == `validated`) {
      var statusPretty = `<span class="badge badge-secondary-primary">${element.status_pretty}</span>`
    } else if (element.status == `paid`) {
      var statusPretty = `<span class="badge badge-secondary-success">${element.status_pretty}</span>`
    }

    if (this.application.permissions[this.permission].can_manage) {
      var copyBtn = `<button data-action="click->${this.controllerName}#copyCommission" type="button" class="btn btn-sm btn-table p-0 mc-tooltip pointer">
                    <span class="material-icons md-sm md-dark">copy_all</span>
                    <span class="mc-tooltiptext">Copiar Comissão</span>
                  </button>`
      var editBtn = `<button data-action="click->${this.controllerName}#editCommission" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                          <span class="material-icons md-sm md-dark">edit</span>
                          <span class="mc-tooltiptext">Editar Comissão</span>
                        </button>`
    } else {
      var editBtn = ``
      var copyBtn = ``
    }

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" data-purchase-token="${element.purchase_token}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" data-purchase-token="${element.purchase_token}">`
    }

    // `<td style="font-size:60%;" scope="col" class="p-1 align-middle pointer">
    //   <p class="mb-0 f-065 mc-tooltip">
    //     <span data-controller="app--helpers--copy" data-copy="${element.token}" data-action="click->app--helpers--copy#copy">${element.token}</span>
    //     <span class="mc-tooltiptext">Clique para Copiar</span>
    //   </p>
    // </td>`
    // `<td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.product_plan_pretty}</td>`
    // `<td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.product_name_pretty}</td>`
    // `<td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.product_service_pretty}</td>`
    // `<td style="font-size:80%;" scope="col" class="p-1 align-middle">${copyBtn}</td>`
    // `<td style="font-size:80%;" scope="col" class="p-1 align-middle">${editBtn}</td>`

    var check = `<td style="font-size:80%;" scope="col" class="p-1 align-middle"></td>`
    if (this.kind == `edit_commission` && element.status != `paid`) {
      check = `<td style="font-size:80%;" scope="col" class="p-1 align-middle">
                <div class="custom-control custom-checkbox px-2 w-50 mt-3">
                  <input type="checkbox" class="custom-control-input" id="check-${element.id}" data-id="${element.id}" data-${this.controllerName}-target="multipleCheck check-${element.id}" data-action="click->${this.controllerName}#editCommission">
                  <label class="custom-control-label f-065" for="check-${element.id}"></label>
                </div>
              </td>`
    } else if (this.kind == `copy_commission`) {
      check = `<td style="font-size:80%;" scope="col" class="p-1 align-middle">
                <div class="custom-control custom-checkbox px-2 w-50 mt-3">
                  <input type="checkbox" class="custom-control-input" id="check-${element.id}" data-id="${element.id}" data-${this.controllerName}-target="multipleCheck check-${element.id}" data-action="click->${this.controllerName}#copyCommission">
                  <label class="custom-control-label f-065" for="check-${element.id}"></label>
                </div>
              </td>`
    } else if (this.kind == `sum_commissions`) {
      check = `<td style="font-size:80%;" scope="col" class="p-1 align-middle">
                <div class="custom-control custom-checkbox px-2 w-50 mt-3">
                  <input type="checkbox" class="custom-control-input" id="check-${element.id}" data-id="${element.id}" data-${this.controllerName}-target="multipleCheck check-${element.id}" data-action="click->${this.controllerName}#bindSumCommissions">
                  <label class="custom-control-label f-065" for="check-${element.id}"></label>
                </div>
              </td>`
    } else if (this.kind == `pay_commissions` && this.canPayCommission(element)) {
      check = `<td style="font-size:80%;" scope="col" class="p-1 align-middle">
                <div class="custom-control custom-checkbox px-2 w-50 mt-3">
                  <input type="checkbox" class="custom-control-input" id="check-${element.id}" data-id="${element.id}" data-${this.controllerName}-target="multipleCheck check-${element.id}" data-action="click->${this.controllerName}#bindSumCommissions">
                  <label class="custom-control-label f-065" for="check-${element.id}"></label>
                </div>
              </td>`
    }

    var rowHtml = `${tableRow}
                    ${check}
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#goToShowPage">${element.name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.journey_status}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.product_name_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.product_kind_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.product_service_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${signedStatus}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${chargedStatus}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${statusPretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.policy_name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.kind_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.controllerNumber.currencyOptionMask(element.gross_amount) }</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${this.controllerNumber.percentOptionMask(element.percentage) }</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${this.controllerNumber.currencyOptionMask(element.net_amount) }</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.account_name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.role_pretty}</td>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="row">
                        <div class="col-3 d-flex">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span data-app--helpers--search-target="footerTable"></span>
                          </div>
                        </div>
                        <div class="col-9 px-0">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                            <div class="dropdown">
                              <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${this.controllerNumber.numberMask(pagination.itemsOnPage)}</button>
                              <div class="dropdown-menu dropdown-menu-right menu">
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="300">300</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="750">750</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="1000">1.000</span>
                              </div>
                            </div>
                            <span class="align-self-center mb-1 mr-2 text-muted">${this.controllerNumber.numberMask(pagination.fromItem)}-${this.controllerNumber.numberMask(pagination.toItem)} de ${this.controllerNumber.numberMask(pagination.totalItems)}</span>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                          </div>
                        </div>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  doSumFooter(mode) {
    var html = `<div class="row">
                  <div class="col-4 d-flex py-2">
                    <div class="card-actions align-items-center justify-content-end py-0 f-065">
                      <span data-${this.controllerName}-target="bindSum"></span>
                    </div>
                  </div>
                  <div class="col-8 d-flex justify-content-end">
                    <div class="card-actions align-items-center justify-content-end py-0 f-065">
                      <button type="button" class="btn btn-flat-primary btn-sm py-2 btn-table f-065 pointer text-right w-100 d-none" data-mode="pay" data-action="click->${this.controllerName}#payCommissions" data-${this.controllerName}-target="payCommissionBtn">Pagar Comissões</button>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.footerTableTarget.innerHTML = html)
    }).then(() => {
      if (mode == `pay`) {
        controller.payCommissionBtnTarget.classList.remove(`d-none`)
      } else {
        
      }
    })
  }

  showClearBtn() {
    this.clearListBtnTarget.classList.remove(`d-none`)
    this.optionBtnTarget.classList.add(`d-none`)
  }

  clearList() {
    this.clearListBtnTarget.classList.add(`d-none`)
    this.optionBtnTarget.classList.remove(`d-none`)
    this.masterMultipleCheckDivTarget.classList.add(`d-none`)
    this.masterMultipleCheckTarget.checked = false

    this.getControllerByIdentifier("financials--products--commissions--entities--save").stopRefreshing()
    this.doDataTable()
  }

  checkForEditCommission() {
    this.kind = `edit_commission`
    this.doDataTable()

    // this.masterMultipleCheckDivTarget.classList.remove(`d-none`)
    this.clearListBtnTarget.classList.remove(`d-none`)
    this.optionBtnTarget.classList.add(`d-none`)

    this.kind = false
  }

  checkForPayCommission() {
    this.kind = `pay_commissions`
    this.doDataTable()
    this.doSumFooter(`pay`)

    this.masterMultipleCheckDivTarget.classList.remove(`d-none`)
    this.clearListBtnTarget.classList.remove(`d-none`)
    this.optionBtnTarget.classList.add(`d-none`)

    this.kind = false
  }

  checkForSumCommission() {
    this.kind = `sum_commissions`
    this.doDataTable()
    this.doSumFooter(`sum`)

    this.masterMultipleCheckDivTarget.classList.remove(`d-none`)
    this.clearListBtnTarget.classList.remove(`d-none`)
    this.optionBtnTarget.classList.add(`d-none`)

    this.kind = false
  }

  checkForCopyCommission() {
    this.kind = `copy_commission`
    this.doDataTable()

    this.clearListBtnTarget.classList.remove(`d-none`)
    this.optionBtnTarget.classList.add(`d-none`)

    this.kind = false
  }

  checkAll(ev) {
    var checkElement = ev.currentTarget

    this.multipleCheckTargets.forEach(element => {
      if (this.searchInputTarget.value == ``) {
        element.checked = checkElement.checked
      } else {
        if (element.closest(`.itemRow`).classList.contains(`filter-row`)) {
          element.checked = checkElement.checked
        }
      }
    })

    this.bindSumCommissions()
  }

  bindSumCommissions() {
    var bindSum = 0
    var commissionsArray = []

    this.multipleCheckTargets.forEach(check => {
      if (check.checked) {
        commissionsArray[commissionsArray.length] = Number(check.dataset.id)
      }
    })

    this.application.commissions.forEach(commission => {
      if (commissionsArray.includes(commission.id)) {
        bindSum += Number(commission.net_amount)
      }
    })

    this.bindSumTarget.innerText = `Valor Total das Comissões Selecionadas: ${this.controllerNumber.currencyOptionMask(bindSum)}`
  }

  goToShowPage(ev) {
    var token = ev.target.closest(".itemRow").dataset.purchaseToken
    window.open(`/a/contratacoes/${token}`, `_blank`)
  }

  refreshCommissions() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()

    if (this.application.permissions[this.permission].can_manage) {
      var data = { commission: { active: true }, current_user: { current_user_id: this.application.current_user.id, feature: this.permission } }
      var url = "/financials/products/commissions/entities/list"
    } else {
      var data = { commission: { active: true, account_id: this.application.current_user.account_id }, current_user: { current_user_id: this.application.current_user.id, feature: this.permission } }
      var url = "/financials/products/commissions/entities/list_by_account"
    }

    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.application.commissions = response.data.cln

        controller.clearList()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  canPayCommission(commission) {
    if (commission.status == `validated` && commission.policy_id != null && commission.account_id != null && commission.charged_date_id != this.application.current_date.id) {
      return true
    } else {
      return false
    }
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    this.getControllerByIdentifier("app--helpers--console").console(results)
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
